fx.ns("filters", class PhotoFilters extends fx.EventDispatcher {

	constructor(){
        super();
        
        this.filters =  [ { id : 1, label : fx.text("Normal"), filter : filters.photofilters.BaseFilter, thumb : "/app/assets/effects/normal.png" },
                         { id : 2, label : fx.text("Lumière"), filter : filters.photofilters.LumiereFilter, thumb : "/app/assets/effects/lumiere.png", params : {amount : 1.7} },
                         { id : 3, label : fx.text("Contraste"), filter : filters.photofilters.ContrastFilter, thumb : "/app/assets/effects/contrast.png", params : {amount : 1.05, vignette: false} },
                         { id : 4, label : fx.text("Couleur +"), filter : filters.photofilters.SaturateFilter, thumb : "/app/assets/effects/couleur.png", params : {amount : 1.5} },
                         { id : 5, label : fx.text("Netteté"), filter : filters.photofilters.SharpenFilter, thumb : "/app/assets/effects/sharpen.png" },
                         { id : 6, label : fx.text("Vieilli"), filter : filters.photofilters.OldPictureFilter, thumb : "/app/assets/effects/vieux.png" },
                         { id : 7, label : fx.text("Noir & Blanc"), filter : filters.photofilters.BlackWhiteFilter, thumb : "/app/assets/effects/noir&blanc.png" },
                         { id : 8, label : fx.text("Sepia"), filter : filters.photofilters.SepiaFilter, thumb : "/app/assets/effects/sepia.png", params : { amount : 1} },
                         // TODO : this effect is broken
                         { id : 9, label : fx.text("Focus"), filter : filters.photofilters.FocusFilter, thumb : "/app/assets/effects/focus.png",  params: {color : "#000000", vignetteFocusSize: 1.5} },
                         { id : 10,label : fx.text("Vintage"), filter : filters.photofilters.FocusFilter, thumb : "/app/assets/effects/vintage.png", params : {color : "#a0774e", vignetteFocusSize:1.1, contrastMount:1.1, contrastMount2:null, brightnessAmount:1.5} },
                         { id : 11,label : fx.text("Vintage 2"), filter : filters.photofilters.FocusFilter, thumb : "/app/assets/effects/vintage2.png", params : {color :"#000000", vignetteFocusSize:2, contrastMount:0.8, contrastMount2:0.02, brightnessAmount:1.8, specularConstant:1.1} },
                        // { id : 12,label : "Nuage", filter : services.photofilters.NuageFilter, thumb : "/app/assets/effects/nuage.png", params : {amount : 1.05} } 
                        ];
    }

    // no filter and no setting : the photo as it is
    static isPlain(data)
    {
        return (!data.effectName || data.effectName == 1) && !Number(data.luminosity) && !Number(data.saturation) && !Number(data.contrast);
    }

    /**
     * A photo's filter chain, the stage's and the thumbnails' (CoverThumbPhoto) : its luminosity,
     * saturation and contrast settings, then its effect (one of this.filters, or null) on top.
     * @param {Function} add : SVG.js' filter builder
     * @param {Object} data : the photo's component (luminosity, saturation, contrast)
     * @param {filters.photofilters.BaseFilter} effect
     * @param {SVG.Element} element : what the effect is measured on (FocusFilter's light, OldPictureFilter's flood)
     * @param {Boolean} withEffect : false leaves the effect out (the stage's empty place), its settings still as with it
     */
    static chain(add, data, effect, element, withEffect)
    {
        let luminosity = data.luminosity || 0;
        let saturation = data.saturation || 0;
        let contrast = data.contrast || 0;

        // set minimum value for luminosity
        data.luminosity < -70 ? luminosity = -70 : "";

        // set minimum value for contrast (-20) and project the initial contrast value into the new interval
        let interval = [-100, 0], targetInterval = [-20, 0];
        if (data.contrast < 0)
            contrast = (data.contrast - interval[0]) / (interval[1] - interval[0]) * (targetInterval[1] - targetInterval[0]) + targetInterval[0];

        // create luminosity + saturation + contrast filter

        let filtered = add;
        // add luminosity + saturation + contrast filter only if not focus filter
        if (!(effect instanceof filters.photofilters.FocusFilter))
            filtered = add.componentTransfer({
                rgb: { type: 'linear', slope: contrast / 100 + 1, intercept: -(0.3 * (contrast / 100 + 1)) + 0.3 }
            })
                .colorMatrix('saturate', saturation / 100 + 1)
                .colorMatrix('matrix', [luminosity / 100 + 1, 0, 0, 0, 0,
                    0, luminosity / 100 + 1, 0, 0, 0,
                    0, 0, luminosity / 100 + 1, 0, 0,
                    0, 0, 0, 1, 0]);

        // if an effect is already applied to the image, merge the two filters
        if (effect && withEffect !== false)
            effect.addFilter(filtered, element);
    }

    get(id)
    {
        let filterDef = this.filters[0];
        for (let i = 0; i < this.filters.length; i++)
        {
            let filter = this.filters[ i ];
            if (filter.id == id)
            {
                filterDef = filter;
                break;
            }
        }

        return new filterDef.filter(filterDef);
    }


});